import { Component, Input, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectHelper } from '@app/app/page-modules/resource/store/editor/content/helpers/redirect.helper';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { CardsLayoutType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-collection-cards-view',
  templateUrl: './collection-cards-view.component.html',
  styleUrls: ['./collection-cards-view.component.scss'],
})
export class CollectionCardsViewComponent {
  @Input() cards: PlaylistCardShort[] = [];
  @Input() currentLayoutView: CardsLayoutType = 'CardView';

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
  ) {}

  // TODO: Duplicated code - extract logic of path building to one source of truth
  onCardClick(card: PlaylistCardShort): void {
    const uri = NestedPathHelper.resolveCardSlug(card);
    if (!uri) {
      return;
    }

    const currentUrl = this.router.url.split('?')[0];
    const parsedPath = NestedPathHelper.parsePath(currentUrl);

    const isProgramContext = parsedPath?.currentEntity?.type === 'program' || currentUrl.includes('/programs/');
    const isCourseContext = parsedPath?.currentEntity?.type === 'course' || currentUrl.includes('/courses/');
    if (isProgramContext || isCourseContext) {
      const newPath = NestedPathHelper.addEntityToPath(currentUrl, this.resolveEntityType(card), uri, 'content');
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newPath);
      return;
    }

    if (card.type === 'CARD' || card.type === 'EVENT') {
      const newCardPath = NestedPathHelper.addEntityToPath(currentUrl, this.resolveEntityType(card), uri, 'content');
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newCardPath);
      return;
    }

    if (!parsedPath) {
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, `/courses/${uri}/content`);
      return;
    }

    let entityType: 'program' | 'course' = 'course';
    if (parsedPath.currentEntity?.type === 'course') {
      entityType = 'course';
    } else if (parsedPath.currentEntity?.type === 'program') {
      entityType = card.collectionType === 'PROGRAM' ? 'program' : 'course';
    } else if (card.collectionType === 'COURSE') {
      entityType = 'course';
    }

    const newPath = NestedPathHelper.addEntityToPath(currentUrl, entityType, uri, 'content');
    RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newPath);
  }

  private resolveEntityType(card: PlaylistCardShort): 'program' | 'course' | 'card' | 'event' {
    const collectionType = (card.v3CardType || card.collectionType)?.toUpperCase();
    if (card.type === 'EVENT' || collectionType === 'EVENT') return 'event';
    if (card.type === 'CARD') return 'card';
    if (collectionType === 'PROGRAM') return 'program';
    return 'course';
  }
}
